import dynamic from "next/dynamic";
const FullWithBulletsParagraphComponent = dynamic(()=>import("./full-with-bullets-paragraph-component"));
import FullWithBulletsParagraphConfig from "./full-with-bullets-paragraph-config";
import FullWithBulletsParagraphAdvancedConfig from "./full-with-bullets-paragraph-advanced-config";
export default {
    FullWithBulletsParagraphComponent,
    FullWithBulletsParagraphConfig,
    FullWithBulletsParagraphAdvancedConfig
};
